// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".radio-group_fb7d {\n  flex: 1;\n  width: 100%;\n  flex-wrap: wrap;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/RadioGroup.scss","RadioGroup.scss"],"names":[],"mappings":"AAAA;EACI,OAAA;EACA,WAAA;EACA,eAAA;ACCJ","file":"RadioGroup.scss","sourcesContent":[".radio-group {\n    flex: 1;\n    width: 100%;\n    flex-wrap: wrap;\n}\n",".radio-group {\n  flex: 1;\n  width: 100%;\n  flex-wrap: wrap;\n}"]}]);
// Exports
exports.locals = {
	"radio-group": "radio-group_fb7d"
};
module.exports = exports;
